import React from 'react';
import { observer } from 'mobx-react-lite';
import { COLOR_BY_WIN_TYPE, ROUND_WIN_TYPE_VIEW } from '../../../enums/betTypesEnum';
import { useIdsGenerator } from '../../../hooks/useIdsGenerator';

export const TopStatistic = observer(({ statisticList }) => {
  const statisticIds = useIdsGenerator(statisticList);
  return (
    <div className='bb-bet-section-row bb-bet-section-row-top'>
      <div className='bb-bet-section-row-top-inside'>
        {statisticList.map((item, index) => {
          if (item) {
            return (
              <div key={statisticIds[index]} className='bb-bet-left-section-item'>
                <div
                  className={`bb-chip ${
                    COLOR_BY_WIN_TYPE[ROUND_WIN_TYPE_VIEW[item?.winType]]
                  } type-2 md filled`}
                />
              </div>
            );
          }
          return <div key={statisticIds[index]} className='bb-bet-left-section-item' />;
        })}
      </div>
    </div>
  );
});
